import React, {useEffect} from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import useSWR from "swr";
const Categories = (props) => {
  const { data, error } = useSWR(process.env.REACT_APP_DEF_URL + "megaHead");
  const [age, setAge] = React.useState(props.defval);
  const handleChange = (event) => {
    setAge(event.target.value);
    console.log(age)
  };

  
  if (error) return <div>failed to load</div>;
  if (!data) return <div>loading...</div>;
  return (
    <Box sx={{ minWidth: 120 }}>
        
      <FormControl fullWidth>
        <InputLabel id="demo-simple-select-label">Kategori</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={age}
          label="Age"
          onChange={handleChange}
          name="categories_id"
        >
          {data.map((data) => (
            <MenuItem value={data.head_id} name="categories_id">{data.head_name}</MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default Categories;
